import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { LoadingBackdrop } from 'components/common'
import { Mode } from 'constants/Mode'
import { GetUserDetailsQuery, useGetUserDetailsQuery } from 'generated/graphql'
import { normalizeUserForm } from 'helpers'
import { TUserForm } from 'types'

import { EmailConfirmationStatus } from './EmailConfirmationStatus'
import UserForm from './UserForm'

/**
 * Props for the UpdateUser component.
 */
interface IProps {
  /**
   * The ID of the user to be updated.
   */
  userId: number

  /**
   * Optional callback function that is triggered when user data is loaded.
   * @param data - The user details data retrieved from the query.
   */
  onDataLoaded?: (data: GetUserDetailsQuery['userDetails']) => void
}

const UpdateUser = (props: IProps) => {
  const { userId, onDataLoaded } = props
  const { reset } = useFormContext<TUserForm>()

  const { loading, data: userDetailsData } = useGetUserDetailsQuery({
    variables: { id: userId },
    fetchPolicy: 'network-only',
  })

  useEffect(() => {
    if (userDetailsData?.userDetails) {
      reset(normalizeUserForm(userDetailsData.userDetails))

      if (onDataLoaded) {
        onDataLoaded(userDetailsData.userDetails)
      }
    }
  }, [userDetailsData, reset, onDataLoaded])

  return (
    <>
      <EmailConfirmationStatus confirmed={userDetailsData?.userDetails.emailConfirmed ?? false} />
      <UserForm mode={Mode.Update} />
      <LoadingBackdrop loading={loading} />
    </>
  )
}

export default UpdateUser
